import React from 'react';
import { css } from '@emotion/react';

const frameStyles = css`
  width: 100vw;
  height: 100vh;
  border: none;
  display: block;
`;

export default function Home() {
  return <iframe src="/ses-sg-final.html" css={frameStyles} title="SES vs SendGrid Analysis" />;
}
